module.exports = __webpack_public_path__ + "img/图片12.ce114dab.png";